import React from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTrash, faCrown} from "@fortawesome/free-solid-svg-icons";

import {avatarInitials, sortBy} from "../util";

import "./TableWinnerItems.css";

const TableWinnerItems = ({deleted, handleDelete, list, tableSort, deleteButtonText}) => {
  const listCopy = [...list];
  const sortByKey = Object.keys(tableSort).find(key => tableSort[key]);

  sortByKey && listCopy.sort(sortBy(sortByKey, tableSort[sortByKey]));

  if (listCopy.length === 0) return (
    <tr className="table-row">
      <td className="table-data" />
      <td className="table-data">No participant found.</td>
      <td className="table-data" />
      <td className="table-data" />
      <td className="table-data" />
    </tr>
  );

  function Cell({showOnMobile, colSpan, className, children}) {
    const clsMobile = showOnMobile===undefined?"":showOnMobile?'d-table-cell d-md-none':'d-none d-md-table-cell';
    return (
      <td colSpan={colSpan || 1} className={`table-data ${className || ""} ${clsMobile}`}>
        <div className="table-data-text">
          {children}
        </div>
      </td>
    );
  }

  function Avatar({item}) {
    if(item.avatar) {
      return (
        <span className="table-data-initials d-flex align-items-center justify-content-center">
          <img
            alt={`${item.name}'s Avatar`}
            className="table-data-avatar"
            src={item.avatar}
          />
        </span>
      );
    }
    return (
      <span className="table-data-initials">
        {avatarInitials(item.name)}
      </span>
    );
  }

  return (
    listCopy.map(item => {
      const renderNameContent = () => (
        <span className="d-flex align-items-center">
          <Avatar item={item} />
          <div className="table-data-text">{item.name}</div>
        </span>
      );

      return (
        <tr
          className={`table-row${item.won ? " is-winner" : ""}`}
          key={item.id}
        >
          <Cell showOnMobile={true} colSpan="5">
              <span className="d-flex align-items-start">
                <span className={`d-flex align-items-center justify-content-center ${item.won?"visible":"invisible"}`}>
                  <FontAwesomeIcon
                    className="table-data-winner-icon"
                    icon={faCrown}
                  />
                </span>
                <Avatar item={item} />
                <div className="table-data-text">
                  <div className="pb-1">{item.name}</div>
                  <div>{item.company || "N/A"}</div>
                  <div className="pb-1">{item.email}</div>
                  <div>
                    {
                      !deleted
                      && (
                        <div className="hyperlink" onClick={() => handleDelete(item.id)}>
                          {deleteButtonText}
                        </div>
                      )
                    }
                  </div>
                </div>
              </span>
          </Cell>
          <Cell showOnMobile={false}>
            {
              item.won
              && (
                <span className="d-flex align-items-center justify-content-center">
                  <FontAwesomeIcon
                    className="table-data-winner-icon"
                    icon={faCrown}
                  />
                </span>
              )
            }
          </Cell>
          <Cell showOnMobile={false}>
            <span className="d-flex align-items-center">
              <Avatar item={item} />
              <div className="table-data-text">{item.name}</div>
            </span>
          </Cell>
          <Cell showOnMobile={false}>
              {item.company || "N/A"}
          </Cell>
          <Cell showOnMobile={false}>
              {item.email}
          </Cell>
          <Cell showOnMobile={false}>
            {
              !deleted
              && (
                <div className="hyperlink" onClick={() => handleDelete(item.id)}>
                  {deleteButtonText}
                </div>
              )
            }
          </Cell>
        </tr>
      );
    })
  );
};

export default TableWinnerItems;
